<script setup>
import { contactDisplayName } from 'dashboard/composables/useSavedContactNames';
import { useMapGetter } from 'dashboard/composables/store.js';

import SearchResultSection from './SearchResultSection.vue';
import SearchResultContactItem from './SearchResultContactItem.vue';

defineProps({
  contacts: {
    type: Array,
    default: () => [],
  },
  query: {
    type: String,
    default: '',
  },
  hasError: {
    type: Boolean,
    default: false,
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
});

const accountId = useMapGetter('getCurrentAccountId');
</script>

<template>
  <SearchResultSection
    :title="$t('SEARCH.SECTION.CONTACTS')"
    :empty="!contacts.length"
    :query="query"
    :show-title="showTitle"
    :is-fetching="isFetching"
    :has-error="hasError"
  >
    <ul v-if="contacts.length" class="space-y-3 list-none">
      <li v-for="contact in contacts" :key="contact.id">
        <SearchResultContactItem
          :id="contact.id"
          :name="contactDisplayName(contact)"
          :email="contact.email"
          :phone="contact.phoneNumber"
          :additional-attributes="contact.additionalAttributes"
          :account-id="accountId"
          :thumbnail="contact.thumbnail"
          :updated-at="contact.lastActivityAt"
        />
      </li>
    </ul>
  </SearchResultSection>
</template>
